var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconJusticeHammerOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.28857 35.2038H22.4171",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 35.2038V29.1609H6.70569V35.2038",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9016 5.50209L13.236 14.1676C12.2921 15.1116 12.2921 16.642 13.236 17.586L17.0646 21.4146C18.0086 22.3585 19.539 22.3585 20.483 21.4146L29.1484 12.749C30.0925 11.8051 30.0925 10.2746 29.1484 9.33065L25.3199 5.50209C24.376 4.55814 22.8455 4.55814 21.9016 5.50209Z",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8342 17.0753L35.7114 27.9524",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJusticeHammerOutline);
export default __webpack_public_path__ + "static/media/icon_justice_hammer_outline.0c5dfbe153f2b792a5a1f5e94f67d950.svg";
export { ForwardRef as ReactComponent };